import { add as _add, update as _update, deleteAll as _deleteAll, getList as _getList, addAsync as _addAsync } from "../api";
import { dateToString } from "utils/dateUtils";

let BASE_URL = null;
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "date",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 15,
};

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/progress-info`;
}

function normalizeProgressInfoData(data) {
    const { date: dateInMillis } = data;

    const date = new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date),
    };
}

function normalizeData(data) {
    return data.map((d) => normalizeProgressInfoData(d));
}

export function getList({ personalInfoId, onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({
        url: `${BASE_URL}/filecase/${personalInfoId}`,
        data,
        onSuccess,
        onInfo,
        onError,
        normalizer: normalizeData,
    });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function addAsync(payload) {
    return _addAsync({ url: BASE_URL, data: payload });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}
